import {
  ASSIGNMENT_HISTORY_PATH,
  assignmentHistoryIntentPath,
  type AssignmentHistoryEntry,
  type AssignmentHistoryListResponse,
} from '@cortex/domain-project-intake-contract';
import { request } from './_request.js';

/**
 * 案件アサイン履歴 API クライアント。
 *
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business 案件アサイン履歴の一覧取得とアサイン意図の保存を行う API クライアント
 * @graph-connects /projects/assignment-history [calls, via:GET] アサイン履歴の一覧取得
 * @graph-connects /projects/assignment-history/{id}/intent [calls, via:PUT] アサイン意図の保存
 */
export const assignmentHistoryApi = {
  /** アサイン履歴をアサイン実行時刻の新しい順に取得する。 */
  list: async (): Promise<AssignmentHistoryListResponse> =>
    request<AssignmentHistoryListResponse>(ASSIGNMENT_HISTORY_PATH),
  /** アサイン意図を保存し、保存後の履歴を返す。 */
  updateIntent: async (id: string, intent: string): Promise<AssignmentHistoryEntry> =>
    request<AssignmentHistoryEntry>(assignmentHistoryIntentPath(id), {
      method: 'PUT',
      body: JSON.stringify({ intent }),
    }),
};
